import { useEffect, useState } from "react";

/**
 * Returns true when the viewport is at or below the given breakpoint (default
 * 640px, Tailwind's `sm`). Used to shrink fixed-height charts and other
 * desktop-sized UI on phones. Updates live on resize/orientation change.
 */
export default function useIsMobile(maxWidth = 640) {
  const query = `(max-width: ${maxWidth}px)`;
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.matchMedia(query).matches
  );

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const mq = window.matchMedia(query);
    const onChange = (e) => setIsMobile(e.matches);
    setIsMobile(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [query]);

  return isMobile;
}
